import React, { useEffect, useState, useCallback } from 'react';
import { GoogleMap, LoadScript, Marker, DirectionsRenderer } from '@react-google-maps/api';
import { useParams, useNavigate} from "react-router-dom";

import { API_BASE_URL } from '../config';

const mapContainerStyle = {
  width: '100%',
  height: '500px'
};

const center = {
  lat: 36.752887,
  lng: 3.042048
};

const RideMap = () => {
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const { id } = useParams();

  const fetchRideDetails = useCallback(async () => {
    const authToken = sessionStorage.getItem("authToken");
    try {
      const response = await fetch(`${API_BASE_URL}/admin/ride`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          authToken,
          ride_id: id }),
      });
      const data = await response.json();
      if (data.success) {
        const { start_lat, start_lng, end_lat, end_lng } = data.ride;
        setStart({ lat: parseFloat(start_lat), lng: parseFloat(start_lng) });
        setEnd({ lat: parseFloat(end_lat), lng: parseFloat(end_lng) });
      } else {
        console.error('Failed to fetch ride details:', data.message);
      }
    } catch (error) {
      console.error('Error fetching ride details:', error);
    }
  }, [id]);

  useEffect(() => {
    fetchRideDetails();
  }, [fetchRideDetails]);

  useEffect(() => {
    if (start && end) {
      const directionsService = new window.google.maps.DirectionsService();
      directionsService.route(
        {
          origin: start,
          destination: end,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            setDirectionsResponse(result);
          } else {
            console.error('Error fetching directions:', status);
          }
        }
      );
    }
  }, [start, end]);

  return (
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={8}
      >
        {start && (
          <Marker
            position={start}
            icon={{ url: '/assets/start_marker.png', scaledSize: new window.google.maps.Size(32, 32) }}
          />
        )}
        {end && (
          <Marker
            position={end}
            icon={{ url: '/assets/end_marker.png', scaledSize: new window.google.maps.Size(32, 32) }}
          />
        )}
        {directionsResponse && (
          <DirectionsRenderer directions={directionsResponse} />
        )}
      </GoogleMap>
  );
};

export default RideMap;
